import React, { useState } from "react";
import { Col, Form, FormGroup, Input } from "reactstrap";
import { Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { NavLink } from "react-router-dom";
import { MDBFooter, MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import axios from "../../Utils/axios";
import classes from "./Footer.module.css";
import logo from "../../Assets/images/logo-footer.png";
import backgroundFooter from "../../Assets/images/Footer-matching-plat.jpg";
import facebook from "../../Assets/images/footer-facebook.png";
import instagram from "../../Assets/images/footer-instagram.png";
import linkedin from "../../Assets/images/footer-linkedin.png";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({ email: "" });
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/subscribe", formData);
      setFormData({ email: "" });
      alert(t("newsletterButton"));
    } catch (error) {
      console.error(error);
      if (error.response?.data?.error?.email) {
        setErrorMessage(error.response.data.error.email[0]);
      } else {
        setErrorMessage(t("errorMessageGeneric"));
      }
      setErrorDialogOpen(true);
    }
  };

  const handleCloseErrorDialog = () => setErrorDialogOpen(false);

  return (
    <MDBFooter className='text-center text-lg-start text-muted footer-section'
      style={{ backgroundImage: `url(${backgroundFooter})`, paddingTop: "50px" }}>
      <MDBContainer className='text-center text-md-start mt-5'>

        <MDBRow className='mt-3 mb-5'>

          {/* Logo + Description */}
          <MDBCol md="6" lg="6" xl="6" className='mx-auto mb-4 word_wrap'>
            <img src={logo} alt="logo" style={{ maxWidth: '80%', height: 'auto' }} />
            <br /><br />
            <Typography variant="body1" sx={{ color: "#2E2E2E", textAlign: "center", fontFamily: "Lato", fontSize: "18px" }}>
              {t("platformDescription")}
            </Typography>
          </MDBCol>

          {/* Platform links */}
          <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4 word_wrap'>
            <Typography variant="h4" sx={{ color: "#3F4C52", textAlign: { xs: "center", sm: "center", md: "left", }, fontFamily: "DM Serif Display", fontSize: { xs: "1.2rem", sm: "1.2rem", md: "1.2rem", lg: "1.5rem", }, fontStyle: "normal", fontWeight: 400, }} >
              {t("platformTitle")}
            </Typography>
            <br />
            <NavLink to="#" className={classes.footerLink}>{t("contactUs")}</NavLink>
          </MDBCol>

          {/* Legal Info */}
          <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4 word_wrap'>
            <Typography variant="h4" sx={{ color: "#3F4C52", textAlign: { xs: "center", sm: "center", md: "left", }, fontFamily: "DM Serif Display", fontSize: { xs: "1.2rem", sm: "1.2rem", md: "1.2rem", lg: "1.5rem", }, fontStyle: "normal", fontWeight: 400, }} >
              {t("legalInfo")}
            </Typography>
            <br />
            <NavLink to="https://yanacom.fr/wp-content/uploads/2025/09/CGV-YANACOM-Developpement-maintenance-et-infographie.pdf" className={classes.footerLink} target="_blank"
              rel="noopener noreferrer">{t("cgv")}</NavLink><br />
            <NavLink to="https://yanacom.fr/loi-rgpd/" className={classes.footerLink} target="_blank"
              rel="noopener noreferrer">{t("rgpd")}</NavLink><br />
            <NavLink to="/mentions_legales" className={classes.footerLink}>{t("legalMentions")}</NavLink>
          </MDBCol>

          {/* Useful Links */}
          <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-md-0 mb-4 word_wrap'>
            <Typography variant="h4" sx={{ color: "#3F4C52", textAlign: { xs: "center", sm: "center", md: "left", }, fontFamily: "DM Serif Display", fontSize: { xs: "1.2rem", sm: "1.2rem", md: "1.2rem", lg: "1.5rem", }, fontStyle: "normal", fontWeight: 400, }} >
              {t("usefulLinks")}
            </Typography>
            <br />
            <NavLink to="/signup" className={classes.footerLink}>{t("signup")}</NavLink><br />
            <NavLink to="/login" className={classes.footerLink}>{t("login")}</NavLink>
          </MDBCol>
        </MDBRow>

        {/* Newsletter + Social */}
        <MDBRow className='mt-3'>
          <MDBCol md="6" lg="6" xl="6" className='mx-auto mb-4 word_wrap'>
            <Typography variant="h4" sx={{ color: "#3F4C52", fontFamily: "DM Serif Display", fontWeight: 400 }}>
              {t("newsletter")}
            </Typography>
            <br />
            <Form onSubmit={handleSubmit}>
              <FormGroup row>
                <Col sm={8}>
                  <Input
                    id="email"
                    name="email"
                    placeholder={t("newsletterPlaceholder")}
                    type="text"
                    value={formData.email}
                    onChange={handleChange}
                    style={{ borderRadius: "40px", border: "none" }}
                    className="mb-3"
                  />
                </Col>
                <Col sm={4}>
                  <Button
                    type="submit"
                    sx={{
                      backgroundColor: "#4AAE9B", color: "white", borderRadius: "35px", textTransform: "none",
                      "&:hover": { backgroundColor: "#A8C9B0" }
                    }}
                  >
                    {t("newsletterButton")}
                  </Button>
                </Col>
              </FormGroup>
            </Form>

            <Dialog open={errorDialogOpen} onClose={handleCloseErrorDialog}>
              <DialogTitle>{t("errorTitle")}</DialogTitle>
              <DialogContent>
                <Typography>{errorMessage}</Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseErrorDialog} autoFocus>OK</Button>
              </DialogActions>
            </Dialog>
          </MDBCol>

          {/* Social Media */}
          <MDBCol md="6" lg="6" xl="6" className='mx-auto mb-md-0 mb-4 word_wrap'>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem' }}>
              <Typography variant="h4" sx={{ color: "#3F4C52", fontFamily: "DM Serif Display", fontWeight: 400 }}>
                {t("followUs")}
              </Typography>

              <a href="https://www.facebook.com/Yanacom/?locale=fr_FR" target="_blank" rel="noopener noreferrer">
                <img src={facebook} className="icon-box" alt="facebook-icon" />
              </a>
              <a href="https://www.instagram.com/yanacom.agence.web/" target="_blank" rel="noopener noreferrer">
                <img src={instagram} className="icon-box" alt="instagram-icon" />
              </a>
              <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fsarl-yanacom%2Fabout" target="_blank" rel="noopener noreferrer">
                <img src={linkedin} className="icon-box" alt="linkedin-icon" />
              </a>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      <div className='text-center p-4'>
        <p className={classes.footertext}>
          ©2025 Matching Platform | All Rights Reserved | Developed and Designed by{' '}
          <a
            href="https://yanacom.fr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Yanacom
          </a>
        </p>
      </div>
    </MDBFooter>
  );
}

export default Footer;